module.exports = __webpack_public_path__ + "basic-top.svg?812e978d733b0f089228c6ae6f1a9e09";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/basic-top.svg
// module id = 70
// module chunks = 0